import { AgGridReact } from "ag-grid-react";
import { Collapse, Modal, Tag } from "antd";
import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
const { Panel } = Collapse;
 
 const MeterModal = React.memo(({isIdleModalOpen,isInactiveModalOpen,setIsIdleModalOpen,setIsInactiveModalOpen,modalData}) => {

 const mode = useSelector((state) => state.darkMode);
      const { isdarkMode } = mode;
        const color = useSelector((state) => state.ThemeChange);
          const getStatusTag = (status) => {
            //console.log(status);
            switch (status) {
              case "ON":
                return <Tag color="green">On</Tag>;
              case "idle":
                return <Tag color="orange">Idle</Tag>;
              case "OFF":
                return <Tag color="red">Off</Tag>;
              default:
                return <Tag>{status}</Tag>;
            }
          };
const groupColumnPopUp = useMemo(
    () => [
          { headerName: "Device ID", field: "meterid", width: 30, flex: 1 },
      { headerName: "Device Name", field: "metername", width: 130, flex: 1 },
      {
        headerName: "Status",
        field: "meterStatus",
        width: 30,
        flex: 1,
        cellRenderer: ({ value }) => getStatusTag(value),
      },

      {
        headerName: "Last Comm.",
        field: "createdon",
        flex: 1,
        minWidth: 220,
        valueFormatter: (params) => {
          return params.value ? params.value.replace("T", " ") : "";
        },
      },
    ],
    []
  );
  const [activeKey, setActiveKey] = useState("0");

  const handleCollapseChange = (key) => {
    setActiveKey(activeKey === key ? null : key); // toggle
  };

  return (
    <Modal
//      title={
//   <span className={isdarkMode === "dark" ? "text-slate-100" : "text-orange-700"}>
//     {isIdleModalOpen
//       ? "IDLE LIST CONVERTERS WISE"
//       : "INACTIVE LIST CONVERTERS WISE"}
//   </span>
// }

       open={isIdleModalOpen || isInactiveModalOpen}
  onCancel={() => {
    setIsIdleModalOpen(false);
    setIsInactiveModalOpen(false);
  }}
  className={isdarkMode ? "dark-modal-Pop-Up" : "no-padding-modal"}  
      footer={null}
      width="60%"
      style={{ top: 100, left:10, padding:0,maxHeight:"80vh",overflowY:"auto"}}
    //   styles={}
    //   bodyStyle={{ padding: 0, maxHeight: "80vh", overflowY: "auto" ,}}
    >
       <div
      style={{
        padding: 5,
        paddingTop:10,
        borderRadius: "3px 3px 0 0",
        backgroundColor: color.themeConfig.colorPrimary
      }}
      className={` text-lg  text-white `}
  
    >
      <p
        className={` ${
          isdarkMode ? "text-white" : "text-white"
        } `}
      >
     {isIdleModalOpen? "IDLE LIST CONVERTERS WISE": "INACTIVE LIST CONVERTERS WISE"}
      </p>
 
    </div>
      <Collapse
        accordion
        activeKey={activeKey}
        onChange={handleCollapseChange}
        className="custom-collapse"
      >
        {Object.entries(modalData)?.map(([converter, meters], i) => (
         <Panel
  key={i}
  className={`rounded-t-xl ${
    isdarkMode ? "dark-collapse" : "light-collapse"
  }`}
  header={
    <div className="flex justify-between items-center">
      <span className="min-w-[100px] font-semibold">{converter}</span>
      <Tag className="border-0 p-1 px-2" color="purple">
        Meters {meters.length}
      </Tag>
    </div>
  }
  bodyStyle={{ padding: "12px" }}  // ⬅ added padding
>
  <div
    className="custom-grid-wrapper"
    style={{
      "--ag-header-background-color": color.themeConfig.colorPrimary,
      "--ag-header-foreground-color": "#fff",
      "--ag-header-group-bg": color.themeConfig.colorPrimaryShade,
      width: "100%",
      overflowY: "auto",
    }}
  >
    <AgGridReact
      suppressRowTransform={true}
      rowData={meters}
      domLayout="autoHeight"
      columnDefs={groupColumnPopUp}
      // onRowClicked={handleParameters}
    />
  </div>
</Panel>

        ))}
      </Collapse>
    </Modal>
  );
});
export default MeterModal